module.exports = __webpack_public_path__ + "img/manage-vehicle-1.92f2734c.gif";